import React from 'react';
import { Text } from '@etiquette-ui/dynamic-table-components';
import RowContainer from 'components/Table/RowContainer';
import { getFormattedName, getFormattedPhone } from 'utils/text';
import ArrowButton from 'components/Buttons/ArrowButton';
import { ALERT_TYPES } from '@etiquette-ui/alert-dialog';
import Attended from 'pages/home/pages/Reservations/alert/Attended';
import ViewDetails from '../../cells/ViewDetails';
import LastUpdatedBy from 'components/Table/LastUpdatedBy';

const structure = {
  row: RowContainer,
  columns: [
    {
      flex: 4,
      header: ({ globalState }) => <Text text={globalState.config.translate('Action Item')} style={{ marginLeft: '16px' }} />,
      body: ({ globalState, item }) => (
        <ArrowButton
          onClick={() => {
            globalState.config
              .alert({
                type: ALERT_TYPES.CUSTOM,
                config: {
                  props: {
                    id: item.id,
                  },
                  body: Attended,
                },
              })
              .catch((e) => {});
          }}
          text={globalState.config.translate('Does the client attend?')}
        />
      ),
    },
    {
      flex: 3,
      header: ({ globalState }) => <Text text={globalState.config.translate('Date and Time')} />,
      body: ({ globalState, item }) => <Text text={globalState.config.formatDate(item.scheduledTime)} />,
    },
    {
      flex: 3,
      header: ({ globalState }) => <Text text={globalState.config.translate('Last, First Name')} />,
      body: ({ item }) => <Text text={getFormattedName(item.guest)} />,
    },
    {
      flex: 2,
      header: ({ globalState }) => <Text style={{ justifyContent: 'center' }} text={globalState.config.translate('#ppl')} />,
      body: ({ item }) => <Text style={{ justifyContent: 'center' }} text={item.partySize} />,
    },
    {
      flex: 3,
      header: ({ globalState }) => <Text text={globalState.config.translate('Phone')} />,
      body: ({ item }) => <Text text={getFormattedPhone(item.guest)} />,
    },
    {
      flex: 3,
      header: ({globalState}) => <Text text={globalState.config.translate('Created by')} />,
      body: ({ item }) => <LastUpdatedBy item={item} field={'createdBy'} />,
    },
    {
      flex: 3,
      header: ({globalState}) => <Text text={globalState.config.translate('Last Change')} />,
      body: ({ item }) => <LastUpdatedBy item={item} />,
    },
    {
      flex: 2,
      header: () => <Text text={''} />,
      body: ViewDetails,
    },
  ],
};

export default structure;

